(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
  // close lookbook
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.product__lookbook-main.active_product') && !event.target.closest('.lookbook__dots')) {
      document.querySelector('.lookbook__dots.active_tooltip')?.click();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        var focusableElements = [
          "a",
          "input",
          "select",
          "button"
        ];

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }

            animateElements();
            var $recommendedSlider = $('.recommend_product_listing');

            $recommendedSlider.on( 'ready.flickity', function(event) {
              focusableElements.forEach(function(focusableElement) {
                document.querySelectorAll('.recommend_product_listing .slideshow__slide').forEach(function(slide) {
                  slide.querySelectorAll(focusableElement).forEach(function(focusableElem) {
                    focusableElem.tabIndex = "-1"
                  })
                });
              });
              focusableElements.forEach(function(focusableElement) {
                document.querySelectorAll('.recommend_product_listing .slideshow__slide.is-selected').forEach(function(slide) {
                  slide.querySelectorAll(focusableElement).forEach(function(focusableElem) {
                    focusableElem.tabIndex = "0"
                  })
                });
              });
            });

            $recommendedSlider.on( 'change.flickity', function(event,index) {
              focusableElements.forEach(function(focusableElement) {
                document.querySelectorAll('.recommend_product_listing .slideshow__slide').forEach(function(slide) {
                  slide.querySelectorAll(focusableElement).forEach(function(focusableElem) {
                    focusableElem.tabIndex = "-1"
                  })
                });
              });
              focusableElements.forEach(function(focusableElement) {
                document.querySelectorAll('.recommend_product_listing .slideshow__slide.is-selected').forEach(function(slide) {
                  slide.querySelectorAll(focusableElement).forEach(function(focusableElem) {
                    focusableElem.tabIndex = "0"
                  })
                });
              });
            });

            $recommendedSlider.flickity({
              avoidReflow: true,
              pageDots: true,
              prevNextButtons: true,
              groupCells: true,
              lazyLoad: true,
              wrapAround: true,
              cellAlign: 'left',
            });

          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
